import { Field } from 'pbts/c1/api/form/v1/form'

/**
 * Checks if a field should be visible to the user based on its provider config.
 * - AdminConfig with showToUser = false: hidden
 * - All other configs: visible
 */
export const isFieldVisibleToUser = (field: Field): boolean => {
    if (field.providerConfig.oneofKind === 'adminConfig') {
        return field.providerConfig.adminConfig.showToUser
    }
    return true
}

/**
 * Checks if a field should be rendered as read-only based on its provider config.
 * - AdminConfig with showToUser = true: read-only (shows default value)
 * - All other configs: editable
 */
export const isFieldReadOnly = (field: Field): boolean => {
    if (field.providerConfig.oneofKind === 'adminConfig') {
        return field.providerConfig.adminConfig.showToUser
    }
    return false
}

/**
 * Checks if a field's value is provided by admin configuration.
 * When true, the frontend should skip required validation since the value
 * is computed on the backend (either via CEL expression or static default).
 */
export const isFieldValueProvidedByAdmin = (field: Field): boolean => {
    return field.providerConfig.oneofKind === 'adminConfig'
}

/**
 * Checks if a string slice field should have its default values locked.
 * - SharedConfig with lockDefaultValues = true: locked
 * - All other configs: unlocked
 */
export const isStringSliceFieldLocked = (field: Field): boolean => {
    if (field.type.oneofKind !== 'stringSliceField') {
        return false
    }
    if (field.providerConfig.oneofKind === 'sharedConfig') {
        return field.providerConfig.sharedConfig.lockDefaultValues
    }
    return false
}
